export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://app.jitihada.co.tz/api';

export const AUTH_STORAGE_KEY = 'inmotion-admin-auth';

export const PUBLIC_API_TOKEN = process.env.REACT_APP_API_TOKEN || '';
